// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type CheckCircle20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckCircle20Filled: FC<CheckCircle20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m9.07 12.625 4.339-4.32-.93-.93-3.409 3.39-1.55-1.53-.929.93 2.48 2.46ZM10 17c-.96 0-1.865-.182-2.716-.547A7.056 7.056 0 0 1 5.05 14.95a7.055 7.055 0 0 1-1.504-2.233A6.821 6.821 0 0 1 3 10c0-.972.182-1.88.547-2.725a7.056 7.056 0 0 1 3.737-3.728A6.822 6.822 0 0 1 10 3c.972 0 1.88.182 2.725.547a7.084 7.084 0 0 1 3.728 3.728C16.818 8.119 17 9.028 17 10c0 .96-.182 1.866-.547 2.716a7.056 7.056 0 0 1-3.728 3.737A6.803 6.803 0 0 1 10 17Z" />
        </svg>
    );
};

export default CheckCircle20Filled;
